export enum EPushWorkerUrls {
  iFramePage = '/web-push-subscribe-iframe',
  popupPage = '/web-push-subscribe-popup',
  workerScript = '/push-worker.js',
  manifest = '/manifest.json',
}
